export default  {"src":"/_next/static/image/public/images/illustrations/mentor.ebf363b041939dfdf45fa94aa8548e60.svg","height":1200,"width":1600};